import TextField from '@mui/material/TextField';

const FromTextField = ({
  onChange = (event: any) => { onChange(event); }
}) => (
  <TextField id="tfgenpinno"
    label="現品票番号"
    size="small"
    inputProps={{ maxLength: 7 }}
    onChange={(event: any) => { onChange(event); }}
  />
);

export default FromTextField;